import { BookOpen, FileText, ListChecks, Newspaper, Package } from 'lucide-react';

const SERVICES = [
  [Newspaper, 'Newsletters & magazines', 'Like the alumni magazine we mailed for the Berkeley Carroll School in Park Slope, all out the door in one day.'],
  [FileText, 'Annual reports & appeals', 'Annual reports, fundraising letters and self mailers, personalized or generic, folded, stuffed, sealed and addressed.'],
  [BookOpen, 'Catalogs', 'Thousands of catalogs a season for Trimco, the Brooklyn store-display company, plus catalogs for a tour bus company and China Sprout.'],
  [Package, 'Package services', 'Bulk mailing of books, promotional items and samples, packed and sent at the best postal rates.'],
] as const;

const CLIENTS = ['Berkeley Carroll School', 'Trimco Display', 'China Sprout', 'St. Francis College', "St. Ann's Warehouse", 'Douglas Elliman', 'Comme des Garçons'];

/** "Who we've mailed for" box on the Direct Mail page, drawn from selectmail.com. */
export function ClientsBox() {
  return (
    <div className="mt-8 border border-foreground">
      <div className="bg-[hsl(var(--brand-blue))] px-4 py-3 text-primary-foreground">
        <div className="text-[11px] font-semibold uppercase tracking-[0.18em] opacity-80">From our files</div>
        <h3 className="font-[family-name:var(--font-heading)] text-2xl font-semibold">More than postcards</h3>
      </div>
      <div className="grid gap-0 sm:grid-cols-2">
        {SERVICES.map(([Icon, t, d], i) => (
          <div key={t} className={`p-4 ${i > 0 ? 'border-t border-foreground' : ''} ${i === 1 ? 'sm:border-t-0' : ''} ${i % 2 === 1 ? 'sm:border-l' : ''}`}>
            <Icon className="h-5 w-5" aria-hidden />
            <div className="mt-2 font-semibold">{t}</div>
            <p className="text-sm text-muted-foreground">{d}</p>
          </div>
        ))}
      </div>
      <div className="flex gap-3 border-t border-foreground bg-[hsl(var(--brand-blue))]/10 p-4">
        <ListChecks className="mt-0.5 h-5 w-5 shrink-0 text-[hsl(var(--brand-blue))]" aria-hidden />
        <div><div className="font-semibold">Specialized mailing lists</div><p className="text-sm text-muted-foreground">Don't have a list? We can get you one: by geography (neighborhood, zip code or carrier route), by household income, or by buying habits, so your mail reaches the people most likely to respond.</p></div>
      </div>
      <div className="border-t border-foreground p-4">
        <div className="text-xs font-semibold uppercase tracking-wider">Some of the clients who trust us</div>
        <ul className="mt-2 flex flex-wrap gap-2">{CLIENTS.map((c) => <li key={c} className="border border-border px-2.5 py-1 text-sm">{c}</li>)}</ul>
        <p className="mt-3 text-sm italic">"We know that looking for a mail house starts with price. It ends with service." <span className="not-italic text-muted-foreground">— George Fiala</span></p>
      </div>
    </div>
  );
}
